import { colors } from './colors';
import { borders } from './borders';
import { radii } from './radii';
import { shadows } from './shadows';
import { sizes } from './sizes';
import { space } from './space';
import { borderWidths } from './borderWidths';
import * as typography from './typography';

export const foundations = {
  colors,
  borders,
  borderWidths,
  radii,
  shadows,
  sizes: {
    container: sizes.container,
    ...sizes.largeSizes,
  },
  space,
  ...typography,
};
